import {Fragment} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {Button, Segment} from 'semantic-ui-react';
import MultiFetcher from '../shared/fetches/multi-fetcher';
import ReportForm from './form';
import StartStudentCourse from '../shared/start-student-course';
import StudentCourseMenu from '../shared/student_course_menu';
import Error from '../shared/error';
import Ranks from './ranks';
import {fetchStudentReports} from '../../redux/actions/report';
import {endStudentCourse, fetchStudentCourse} from '../../redux/actions/student-course';

function ReportContainer(props) {
  return (
    <Fragment>
      <Ranks/>
      <StudentCourseMenu render={renderContent.bind(null, props)}/>
    </Fragment>
  );
}

function renderContent(props, studentCourse) {
  return <MultiFetcher
    actions={[
      fetchStudentReports,
      fetchStudentCourse.bind(null, studentCourse.id),
    ]}
    stateSelectors={{
      reports: state => state.reports,
      homeworks: state => state.homeworks,
    }}
    renderEmpty={renderEmpty.bind(null, props, studentCourse.id)}
    renderError={renderError.bind(null, props, studentCourse.id)}
  >
    {({reports, homeworks}) => (
      <Fragment>
        {(homeworks.length === 0) && (
          <Segment textAlign='center'>
            <p>تمامی تکالیف این دوره آموزشی انجام شده است.</p>
            <p className='red-text'>لطفا پس از ثبت نتیجه آزمون برای این کورس اقدام به بستن آن نمایید.</p>
            {studentCourse.hasExamReport ? (
              <Button
                primary
                content='بستن این دوره آموزشی'
                onClick={props.endStudentCourse.bind(null, studentCourse.id)}
              />
            ) : (
              <Button
                positive
                as={Link}
                to='/exam-report'
                content='ثبت گزارش آزمون'
              />
            )}
          </Segment>
        )}

        <Segment>
          <ReportForm
            homeworks={homeworks}
            reports={reports.filter(report => (report.studentCourse === studentCourse.id))}
            studentCourse={studentCourse}
          />
        </Segment>

      </Fragment>
    )}
  </MultiFetcher>;
}

function renderEmpty(props, studentCourseId, emptyDataKeys) {
  if (emptyDataKeys.length === 1 && emptyDataKeys.includes('reports')) return null;
  if (emptyDataKeys.includes('studentCourse'))
    return (<StartStudentCourse studentCourseId={studentCourseId}/>);
  return null;
}

function renderError(props, studentCourseId, errorKeys) {
  if (errorKeys.length === 1 && errorKeys.includes('studentCourse'))
    return endStudentCourse(props, studentCourseId);
  return <Error/>;
}

export default connect(null, {endStudentCourse})(ReportContainer);
